

import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import EnglishQuestionGroupForm from "./components/EnglishQuestionGroupForm";
import {
  useCreateEnglishQuestionGroupMutation,
} from "../../slices/englishQuestionGroupApiSlice";

const EnglishQuestionGroupCreate = () => {
  const navigate = useNavigate();

  const [
    createEnglishQuestionGroup,
    {
      isLoading,
      error,
    },
  ] = useCreateEnglishQuestionGroupMutation();

  const handleSubmit = async (formData) => {
    try {
      await createEnglishQuestionGroup(formData).unwrap();

      toast.success("English question group created successfully");

      navigate("/english-questions-groups");
    } catch (err) {
      const message =
        err?.data?.message ||
        err?.error ||
        "Failed to create English question group";

      toast.error(message);
    }
  };

  const handleCancel = () => {
    navigate("/english-questions-groups");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900">
                Create English Question Group
              </h1>

              <p className="mt-1 text-sm text-slate-500">
                Create a passage, cloze test, caselet, common directions, or
                sentence-based question group.
              </p>
            </div>

            <button
              type="button"
              onClick={handleCancel}
              disabled={isLoading}
              className="inline-flex items-center justify-center rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
            >
              Cancel
            </button>
          </div>
        </div>

        {/* Error */}
        {error && (
          <div className="mb-6 rounded-xl border border-red-200 bg-red-50 p-4">
            <div className="flex items-start gap-3">
              <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-xs font-bold text-red-600">
                !
              </div>

              <div>
                <h2 className="text-sm font-semibold text-red-800">
                  Unable to create question group
                </h2>

                <p className="mt-1 text-sm text-red-700">
                  {error?.data?.message ||
                    error?.error ||
                    "Something went wrong while creating the question group."}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Form */}
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="border-b border-slate-200 px-6 py-5">
            <h2 className="text-lg font-semibold text-slate-900">
              Group Information
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Enter the group details and shared content. Questions can be
              added after the group is created.
            </p>
          </div>

          <div className="p-6">
            <EnglishQuestionGroupForm
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isSubmitting={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnglishQuestionGroupCreate;

